export const POST_LIST_REQUEST = "POST_LIST_REQUEST";
export const POST_LIST_SUCCESS = "POST_LIST_SUCCESS";
export const POST_LIST_FAIL = "POST_LIST_FAIL";

export const POST_DETAILS_REQUEST = "POST_DETAILS_REQUEST";
export const POST_DETAILS_SUCCESS = "POST_DETAILS_SUCCESS";
export const POST_DETAILS_FAIL = "POST_DETAILS_FAIL";

export const POST_CREATE_REVIEW_REQUEST = "POST_CREATE_REVIEW_REQUEST";
export const POST_CREATE_REVIEW_SUCCESS = "POST_CREATE_REVIEW_SUCCESS";
export const POST_CREATE_REVIEW_FAIL = "POST_CREATE_REVIEW_FAIL";
export const POST_CREATE_REVIEW_RESET = "POST_CREATE_REVIEW_RESET";

export const POST_UPSERT_REQUEST = "POST_UPSERT_REQUEST";
export const POST_UPSERT_SUCCESS = "POST_UPSERT_SUCCESS";
export const POST_UPSERT_FAIL = "POST_UPSERT_FAIL";
export const POST_UPSERT_RESET = "POST_UPSERT_RESET";

export const POST_DELETE_REQUEST = "POST_DELETE_REQUEST";
export const POST_DELETE_SUCCESS = "POST_DELETE_SUCCESS";
export const POST_DELETE_FAIL = "POST_DELETE_FAIL";
export const POST_DELETE_RESET = "POST_DELETE_RESET";

export const POST_EDIT_REQUEST = "POST_EDIT_REQUEST";
export const POST_EDIT_SUCCESS = "POST_EDIT_SUCCESS";
export const POST_EDIT_FAIL = "POST_EDIT_FAIL";
export const POST_EDIT_RESET = "POST_EDIT_RESET";

export const POST_BY_BUSINESS_LIST_REQUEST = "POST_EDIT_REQUEST";
export const POST_BY_BUSINESS_LIST_SUCCESS = "POST_BY_BUSINESS_LIST_SUCCESS";
export const POST_BY_BUSINESS_LIST_FAIL = "POST_BY_BUSINESS_LIST_FAIL";
export const POST_BY_BUSINESS_LIST_RESET = "POST_BY_BUSINESS_LIST_RESET";

// LIKE
export const POST_LIKE_REQUEST = "POST_LIKE_REQUEST";
export const POST_LIKE_SUCCESS = "POST_LIKE_SUCCESS";
export const POST_LIKE_FAIL = "POST_LIKE_FAIL";
export const POST_LIKE_RESET = "POST_LIKE_RESET";

// REVIEW
export const POST_REVIEW_LIST_REQUEST = "POST_REVIEW_LIST_REQUEST";
export const POST_REVIEW_LIST_SUCCESS = "POST_REVIEW_LIST_SUCCESS";
export const POST_REVIEW_LIST_FAIL = "POST_REVIEW_LIST_FAIL";

// SHARE
export const POST_SHARE_REQUEST = "POST_SHARE_REQUEST";
export const POST_SHARE_SUCCESS = "POST_SHARE_SUCCESS";
export const POST_SHARE_FAIL = "POST_SHARE_FAIL";
export const POST_SHARE_RESET = "POST_SHARE_RESET";

// VIEW
export const POST_VIEW_REQUEST = "POST_VIEW_REQUEST";
export const POST_VIEW_SUCCESS = "POST_VIEW_SUCCESS";
export const POST_VIEW_FAIL = "POST_VIEW_FAIL";
export const POST_VIEW_RESET = "POST_VIEW_RESET";

export const POST_ANALYTICS_REQUEST = "POST_ANALYTICS_REQUEST";
export const POST_ANALYTICS_SUCCESS = "POST_ANALYTICS_SUCCESS";
export const POST_ANALYTICS_FAIL = "POST_ANALYTICS_FAIL";
